import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

import {
  DISCORD_LINK,
  EMAIL_LINK,
  MEDIUM_LINK,
  TELEGRAM_LINK,
  TWITTER_LINK,
} from 'modules/common';
import { useTranslation } from 'modules/i18n';

import { ReactComponent as DiscordIcon } from '../assets/discord.svg';
import { ReactComponent as MediumIcon } from '../assets/medium.svg';
import { ReactComponent as TelegramIcon } from '../assets/telegram.svg';
import { ReactComponent as TwitterIcon } from '../assets/twitter.svg';
import translation from './footer.translation';

export const FOOTER_HEIGHT = 80;

const YEAR = new Date().getFullYear();
export function Footer(): JSX.Element {
  const { t, keys } = useTranslation(translation);
  const { classes } = useStyles();

  return (
    <footer className={classes.container}>
      <div className={classes.info}>
        <Typography
          variant="body3"
          sx={theme => ({
            color: theme.palette.grey[500],
            textAlign: 'center',
          })}
        >
          {t(keys.allRights, { year: YEAR, email: EMAIL_LINK })}
        </Typography>
      </div>

      <div className={classes.social}>
        <a
          className={classes.iconLink}
          href={TWITTER_LINK}
          target="_blank"
          rel="noreferrer"
        >
          <TwitterIcon />
        </a>

        <a
          className={classes.iconLink}
          href={TELEGRAM_LINK}
          target="_blank"
          rel="noreferrer"
        >
          <TelegramIcon />
        </a>

        <a
          className={classes.iconLink}
          href={MEDIUM_LINK}
          target="_blank"
          rel="noreferrer"
        >
          <MediumIcon />
        </a>

        <a
          className={classes.iconLink}
          href={DISCORD_LINK}
          target="_blank"
          rel="noreferrer"
        >
          <DiscordIcon />
        </a>
      </div>
    </footer>
  );
}

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: FOOTER_HEIGHT,

    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: theme.spacing(4, 0),
    },
  },

  info: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },

  tutorial: {
    '&&': {
      marginLeft: theme.spacing(26),

      [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(16),
      },

      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(6),
        marginLeft: 0,
      },
    },
  },
  social: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 138,

    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(6),
    },
  },

  iconLink: {
    color: theme.palette.grey[500],

    '&:hover': {
      color: theme.palette.grey[600],
    },
  },
}));
